<template>
  <div>
    <qrcode-stream v-if="openCamera" key="qrcode-scan" :camera="camera" :track="paintOutline" @decode="onDecode" @init="onInit">
      <div v-if="validationSuccess" class="validation-success">
        Сканирование успешно
      </div>

      <div v-if="validationFailure" class="validation-failure">
        {{ error }}
      </div>

      <div v-if="validationPending" class="validation-pending">
        Обработка
      </div>
    </qrcode-stream>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'QrCodeScanner',
  components: { QrcodeStream },
  props: {
    openCamera: Boolean,
  },
  data: () => ({
    isValid: undefined,
    formatCamera: 'auto',
    error: '',
    noRearCamera: false,
    noFrontCamera: false,
  }),
  computed: {
    camera() {
      if (!this.openCamera) {
        return 'off';
      }
      return this.formatCamera;
    },
    validationPending() {
      return this.isValid === undefined
        && this.formatCamera === 'off';
    },

    validationSuccess() {
      return this.isValid === true;
    },

    validationFailure() {
      return this.isValid === false;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    paintOutline(detectedCodes, ctx) {
      // eslint-disable-next-line no-restricted-syntax
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = 'green';

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        // eslint-disable-next-line no-restricted-syntax
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineWidth = 3;
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },
    /**
     * Результат скана QR-кода
     * @param result
     */
    async onDecode(result) {
      this.turnCameraOff();
      this.timeout(500);
      await this.$emit('success', result);
      this.turnCameraOn();
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'Вам необходимо предоставить разрешение на доступ к камере';
        } else if (error.name === 'NotFoundError') {
          this.error = 'На вашем устройстве нет камеры';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'Что-то пошло не так (неполадки с https)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'Камера уже исползуется где-то?';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'Имеющиеся камеры не подходят';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'Сканирование не поддерживается в вашем браузере';
        } else if (error.name === 'InsecureContextError') {
          this.error = 'Доступ к камере разрешен только в безопасном контексте';
        } else if (error.name === 'InsecureContextError') {
          this.error = 'Доступ к камере разрешен только в безопасном контексте';
        } else {
          this.error = `Ошибка камеры (${error.name})`;
        }


        this.$emit('error', this.error);
      }
    },

    turnCameraOn() {
      this.formatCamera = 'auto';
    },

    turnCameraOff() {
      this.formatCamera = 'off';
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
  },
};
</script>

<style scoped>
.validation-success,
.validation-failure,
.validation-pending {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, .8);
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.validation-success {
  color: green;
}

.validation-failure {
  color: red;
}

button {
  position: absolute;
  left: 10px;
  top: 10px;
}

</style>
